import { render, staticRenderFns } from "./DockingMasterDataShipyard.vue?vue&type=template&id=36ccad89&scoped=true&"
import script from "./DockingMasterDataShipyard.vue?vue&type=script&lang=js&"
export * from "./DockingMasterDataShipyard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ccad89",
  null
  
)

export default component.exports